<script>

import ModalStatic from "@/components/ModalStatic.vue";
import {computed, onMounted, ref} from "vue";
import {breakpointState} from "@/utils";
export default {
    name: "ModalDefault",
    components: {
        ModalStatic
    },
    props: {
        content: {
            type: Object,
            required: true
        }
    },
    setup(props, { emit }) {
        const modalOpen = ref(false);
        const overline = ref(props.content.overline??null);
        const headline = ref(props.content.headline??null);
        const subline = ref(props.content.subline??null);
        const intro = ref(props.content.intro??null);
        const imageSrc = ref(props.content.imageSrc??null);
        const imageAlt = ref(props.content.imageAlt??"");
        const claim = ref(props.content.claim??null);
        const description = ref(props.content.description??null);
        const linkLabel = ref(props.content.linkLabel??null);
        const linkHref = ref(props.content.linkHref??null);
        const linkTarget = ref(props.content.linkTarget??null);

        const descriptionClass = computed(() => {
            return {
                "text-expires": props.content.textExpires
            }
        })

        const toggleModal = (state) => {
            modalOpen.value = state;
            if (!state) {
                setTimeout(() => {
                    emit("clear");
                },500);
            }
        }

        const imageShow = computed(() => {
            return imageSrc.value && breakpointState.value.down.indexOf("mobile") !== -1;
        });

        onMounted(() => {
            setTimeout(() => {
                modalOpen.value = true;
            },200);
        })

        return {
            modalOpen,
            overline,
            headline,
            subline,
            intro,
            imageSrc,
            imageAlt,
            claim,
            description,
            descriptionClass,
            linkLabel,
            linkHref,
            linkTarget,
            imageShow,
            toggleModal
        }
    }
}
</script>

<template>
    <modal-static
        :active="modalOpen"
        @open="toggleModal(true)"
        @close="toggleModal(false)"
    >
        <p
            class="modal-static__overline"
            v-if="overline"
            v-html="overline"
        />

        <h2
            class="modal-static__headline"
            v-if="headline"
            v-html="headline"
        />

        <p
            class="modal-static__subline"
            v-if="subline"
            v-html="subline"
        />

        <p
            class="modal-static__intro"
            v-if="intro"
            v-html="intro"
        />

        <div
            class="modal-static__image"
            v-if="imageShow && imageSrc"
        >
            <img class="img-fluid" :src="imageSrc" :alt="imageAlt" />
        </div>

        <div
            class="modal-static__description"
            v-if="description"
        >
            <p :class="descriptionClass" v-html="description"/>
        </div>

        <p v-if="claim" class="modal-static__claim" v-html="claim"/>

        <div v-if="linkLabel && linkHref" class="modal-static__actions">
            <a :href="linkHref" :target="linkTarget" class="mdc-button--primary">
                <span class="mdc-button__label" v-html="linkLabel"/>
            </a>
        </div>
    </modal-static>
</template>
